import { http } from '../utils/http';

export default class Api {
  constructor(baseUrl, auth, headers) {
    this.baseUrl = baseUrl;
    this.auth = auth;
    this.headers = headers;

    if (auth.use_credentials) {
      this.httpCall = (method, url, data, headers) => {
        return http(method, url, data, headers, true);
      };
    } else {
      this.httpCall = http;
    }
  }

  request(method, url, data, headers) {
    return this.httpCall(method, url, data, headers);
  }
}
